import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

export interface BBToasterOptions extends Partial<IndividualConfig> {
	title?: string;
	message?: string;
	translate?: boolean;
	type?: 'success' | 'error' | 'info' | 'warning';
}

@Injectable()
export class ToasterService {
	defaultSettings: Partial<IndividualConfig> = {
		timeOut: 5000,
		extendedTimeOut: 1500,
		progressBar: true,
		closeButton: true
	};

	constructor(
		private toastr: ToastrService,
		private translate: TranslateService
	) {
	}

	success(options: BBToasterOptions): void {
		this._toastrMsg({...{
			type: 'success',
			timeOut: 3000
		}, ...options});
	}

	error(options: BBToasterOptions): void {
		this._toastrMsg({...{
			type: 'error',
			timeOut: 0,
			extendedTimeOut: 0,
			progressBar: false
		}, ...options});
	}

	info(options: BBToasterOptions): void {
		this._toastrMsg({...{
			type: 'info',
		}, ...options});
	}

	warning(options: BBToasterOptions): void {
		this._toastrMsg({...{
			type: 'warning',
		}, ...options});
	}

	private _toastrMsg(options: BBToasterOptions): void {
		const {translate, type, title} = options;
		let {message} = options;
		if (translate) {
			message = this.translate.instant(message);
		}

		this.toastr[type || 'info'](message, title, {...this.defaultSettings, ...options});
	}
}
